export var PlayerAPIMiddleware = function(api) {
    return function(next) {
        return function(action) {
            window.__PlayerAPI = window.__PlayerAPI || {};
            window.__PlayerAPI.state = api.getState();
            return next(action);
        };
    };
};
